import { ref, getCurrentInstance } from '@vue/composition-api'
import TableApi from '@/api/waiter/Table'

// 卓の楽観更新を共通化する。params で TableApi.updateTable を叩き、
// 成功時は更新後の卓データ(res.data.data)を返し、失敗/想定外レスポンス時は null を返す。
// 呼び出し側は返り値が null のとき元の状態へ復旧する（延長=課金のため既存トグルと同方針）。
export const useTableUpdate = getTableId => {
  const vm = getCurrentInstance().proxy
  const submitting = ref(false)

  const run = async (params, { successMessage, errorMessage } = {}) => {
    submitting.value = true
    try {
      const res = await TableApi.updateTable({ tableId: getTableId(), params })
      if (res?.data?.data) {
        if (successMessage) vm.$toast.success(successMessage)

        return res.data.data
      }
    } catch (_e) {
      // 失敗は下の共通エラー処理へ集約する
    } finally {
      submitting.value = false
    }

    if (errorMessage) vm.$toast.error(errorMessage)

    return null
  }

  return { submitting, run }
}

export default useTableUpdate
